// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BSG-compliant styles for food item modal */
/* Utility class for screen readers */
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

/* Skip link for keyboard users */
.bsg-skip-link {
  position: absolute;
  top: -9999px;
  left: -9999px;
  background: white;
  color: var(--ion-color-secondary);
  padding: 15px;
  z-index: 10000;
  font-weight: bold;
  border: 2px solid var(--ion-color-primary);
  text-decoration: none;
}
.bsg-skip-link:focus {
  top: 10px;
  left: 10px;
}

/* Container styles */
.bsg-modal-container {
  position: relative;
  height: 100%;
}

app-modal-info {
  height: 100vh;
  position: relative;
}

swiper-container {
  width: 100% !important;
  height: 100% !important;
  background-color: var(--background-color);
}

swiper-slide {
  width: 100% !important;
}

ion-page {
  background: transparent;
}

/* Slide column styles */
.slide-col {
  top: 0;
  bottom: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
  background-size: 100% 30vh !important;
  overflow: auto;
}
.slide-col.add-background {
  background-size: cover;
}

/* Header wrapper styles */
.header-wrapper {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  align-items: center;
}

/* Category heading */
.category-heading {
  margin: 0;
  font-size: 18px;
  color: var(--ion-color-secondary);
}

/* Back button */
.bsg-back-button {
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  /* Focus styles */
  /* Hover state */
  /* Key focus styles */
}
.bsg-back-button:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.bsg-back-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.bsg-back-button:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.bsg-back-button ion-icon {
  width: 20px;
  height: 20px;
}

/* Favorite button */
.add_fav_btn {
  width: 40px;
  height: 40px;
  background: white;
  border-radius: 50%;
  box-shadow: 0px 0px 20px 0px rgba(79, 97, 79, 0.1490196078);
  display: flex;
  align-items: center;
  justify-content: center;
  /* Focus styles */
  /* Key focus styles */
  /* Hover state */
}
.add_fav_btn.no-shadow {
  box-shadow: none;
}
.add_fav_btn:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.add_fav_btn:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.add_fav_btn:hover {
  background-color: rgba(0, 0, 0, 0.02);
}
.add_fav_btn ion-icon {
  width: 25px;
  height: 25px;
}

/* Image wrapper styles */
.image-wrapper {
  position: relative;
  margin: 0;
}

.main-img {
  height: 30vh;
  width: 100%;
  margin: 0 auto 0px;
}
.main-img.default-img {
  height: 35vh;
  width: 100px !important;
}

/* Information section styles */
.info {
  padding: 20px 20px 0px 20px;
}
.info .title {
  text-align: left;
  font-size: 25px;
  line-height: var(--modal-info-title-line-height);
  margin-bottom: 6px;
  padding-top: 10px;
  color: var(--ion-color-secondary);
  display: flex;
  align-items: center;
}
.info .desc {
  text-align: left;
  font-size: var(--modal-info-desc-font-size);
  font-family: AppFont, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding-bottom: 10px;
  color: var(--ion-color-secondary);
}

/* Info button */
.bsg-info-button {
  background: transparent;
  border: none;
  padding: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border-radius: 50%;
  margin-left: 5px;
  /* Focus styles */
  /* Key focus styles */
  /* Hover state */
}
.bsg-info-button:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.bsg-info-button:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.bsg-info-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.bsg-info-button ion-icon {
  font-size: 17px;
}

/* Ingredients section */
.ingrediants-section {
  display: flex;
  justify-content: flex-end;
  padding: 10px 0px;
  align-items: center;
  width: 100%;
}
.ingrediants-section .bsg-remove-ingredients-button {
  cursor: pointer;
  text-align: left;
  font-size: 16px;
  font-family: AppFontBold, sans-serif;
  line-height: var(--modal-info-desc-line-height);
  padding: 8px;
  color: var(--ion-color-primary);
  text-decoration: underline;
  background: transparent;
  border: none;
  border-radius: 4px;
  /* Focus styles */
  /* Key focus styles */
  /* Hover state */
}
.ingrediants-section .bsg-remove-ingredients-button:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.ingrediants-section .bsg-remove-ingredients-button:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.ingrediants-section .bsg-remove-ingredients-button:hover {
  color: #5a894c;
  text-decoration: underline;
}
@media (max-width: 992px) {
  .ingrediants-section .bsg-remove-ingredients-button {
    width: 50%;
    text-align: right;
  }
}

/* Option group styles */
.option-group-col {
  flex-grow: 1;
  overflow: auto;
  flex-shrink: 1;
  flex-basis: auto;
  padding: 15px 20px;
}

.option-group-description {
  line-height: 1.3;
  padding: 10px 25px 0px 20px;
  color: var(--ion-color-secondary);
  font-size: 16px;
  text-align: left;
  font-family: AppFontBold, sans-serif;
}

.show-option-groups {
  background: white;
  display: flex;
  align-items: center;
}

.last-item {
  height: 75px;
}

/* Notes input */
.input-notes {
  padding: 20px 20px 80px;
}
.input-notes ion-item {
  border: 1.5px solid var(--ion-color-primary);
  border-radius: 16px;
  margin-bottom: 10px;
  /* Focus styles */
}
.input-notes ion-item:focus-within {
  border-color: var(--ion-color-primary);
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}
.input-notes .container {
  position: relative;
}
.input-notes .container ion-label {
  position: absolute;
  left: 20px;
  background: white;
  top: -7px;
  z-index: 999;
  padding: 0px 10px;
  color: var(--ion-color-secondary);
}

/* Vegan indicators */
.vegan-block {
  display: flex;
  align-items: center;
}
.vegan-block ion-img {
  width: 35px;
  height: 24px;
}
.vegan-block p {
  text-transform: capitalize;
  margin-right: 5px;
  font-size: 12px;
  color: var(--ion-color-secondary);
}

/* Footer and button styles */
.button-footer-block {
  background: white;
  margin: 0px !important;
  padding: 15px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  z-index: 999;
  box-shadow: 0px -4px 50px 0px rgba(0, 0, 0, 0.1019607843);
  display: flex;
  flex-direction: column;
  font-size: 16px;
}
.button-footer-block ion-button {
  --padding-start: 24px;
  --padding-end: 7px;
  width: 100%;
  position: relative;
  /* Focus styles */
  /* Key focus styles */
}
.button-footer-block ion-button:focus {
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}
.button-footer-block ion-button:focus-visible {
  box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);
}
.button-footer-block ion-button .buuton-text {
  font-size: var(--modal-info-button-font-size);
  color: var(--modal-info-button-text-color);
  margin-right: 0;
}
.button-footer-block ion-button .buuton-text.one-button {
  margin-right: 35px;
}
.button-footer-block ion-button .button-icon {
  position: absolute;
  right: 5px;
  height: 34px;
  width: 34px;
}
.button-footer-block .footer-price-section {
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
}
.button-footer-block .footer-price-section .text-hint {
  font-family: AppFont, sans-serif;
  font-size: 14px;
  color: var(--ion-color-secondary);
}
.button-footer-block .footer-price-section .wrapper-with-quantity {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.button-footer-block .footer-price-section .wrapper-with-quantity .price-text {
  font-family: AppFontBold, sans-serif;
  font-size: 18px;
  color: var(--ion-color-secondary);
}

/* Quantity selector styles */
.quantity-selector {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.quantity-selector .quantity {
  color: var(--ion-color-secondary);
  font-size: 20px;
  font-family: AppFontBold;
  margin: 0 10px;
}
.quantity-selector .quantity-btn {
  background: transparent;
  border: none;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  /* Focus styles */
  /* Key focus styles */
  /* Hover state */
}
.quantity-selector .quantity-btn:focus {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.quantity-selector .quantity-btn:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}
.quantity-selector .quantity-btn:hover:not([disabled]) {
  background-color: rgba(0, 0, 0, 0.05);
}
.quantity-selector .quantity-btn.add-opacity {
  opacity: 0.5;
}
.quantity-selector .quantity-btn[disabled] {
  cursor: not-allowed;
}
.quantity-selector .quantity-btn ion-icon {
  width: 30px;
  height: 30px;
}

/* Container for scrollable content */
.style-block {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 120px;
}

/* Focus trap marker elements for modal focus management */
.bsg-focus-trap-start, .bsg-focus-trap-end {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

/* Keyboard focus indicators */
.bsg-keyboard-focus:focus-visible {
  outline: 3px solid var(--ion-color-primary);
  outline-offset: 2px;
}

/* High contrast mode styles */
.bsg-high-contrast {
  /* Background and container styles */
  /* Header and navigation */
  /* Text and content */
  /* Interactive elements */
  /* Form elements */
  /* Footer elements */
  /* Vegan indicators in high contrast */
  /* Improve skip link visibility in high contrast */
  /* Enhance visibility of option groups */
  /* Add borders to sections for better visual separation */
  /* Announce screen reader content in high contrast mode */
}
.bsg-high-contrast swiper-container {
  background-color: white !important;
}
.bsg-high-contrast .slide-col {
  background: white !important;
}
.bsg-high-contrast .bsg-back-button:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .bsg-back-button ion-icon {
  color: black;
}
.bsg-high-contrast .add_fav_btn {
  background: white;
  border: 2px solid black;
  box-shadow: none;
}
.bsg-high-contrast .add_fav_btn:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .add_fav_btn ion-icon {
  color: black;
}
.bsg-high-contrast .title, .bsg-high-contrast .desc, .bsg-high-contrast .category-heading, .bsg-high-contrast .option-group-description {
  color: black !important;
}
.bsg-high-contrast .info .desc {
  color: black !important;
}
.bsg-high-contrast .bsg-info-button:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .bsg-info-button ion-icon {
  color: black;
}
.bsg-high-contrast .bsg-remove-ingredients-button {
  color: #0078d7 !important;
  text-decoration: underline;
}
.bsg-high-contrast .bsg-remove-ingredients-button:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .input-notes ion-item {
  border-color: black;
}
.bsg-high-contrast .input-notes ion-item:focus-within {
  border-color: #0078d7;
  box-shadow: 0 0 0 3px rgba(0, 120, 215, 0.25);
}
.bsg-high-contrast ion-label {
  background: white !important;
  color: black !important;
}
.bsg-high-contrast .button-footer-block {
  background: white;
  border-top: 2px solid black;
}
.bsg-high-contrast .button-footer-block .text-hint, .bsg-high-contrast .button-footer-block .price-text, .bsg-high-contrast .button-footer-block .quantity {
  color: black !important;
}
.bsg-high-contrast .button-footer-block ion-button {
  /* Add higher contrast to button text and icons */
  /* Disabled button styles for high contrast */
}
.bsg-high-contrast .button-footer-block ion-button:focus {
  box-shadow: 0 0 0 3px #0078d7;
}
.bsg-high-contrast .button-footer-block ion-button .buuton-text {
  color: white !important;
  font-weight: bold;
}
.bsg-high-contrast .button-footer-block ion-button .button-icon {
  color: white !important;
}
.bsg-high-contrast .button-footer-block ion-button[disabled] {
  opacity: 0.6;
  border: 1px dashed black;
}
.bsg-high-contrast .button-footer-block ion-button[disabled] .buuton-text {
  color: #666666 !important;
}
.bsg-high-contrast .quantity-btn {
  /* Disabled button style */
}
.bsg-high-contrast .quantity-btn:focus {
  outline: 3px solid #0078d7;
}
.bsg-high-contrast .quantity-btn ion-icon {
  color: black;
}
.bsg-high-contrast .quantity-btn[disabled], .bsg-high-contrast .quantity-btn.add-opacity {
  opacity: 0.5;
  border: 1px dashed black;
}
.bsg-high-contrast .vegan-block ion-img {
  border: 1px solid black;
}
.bsg-high-contrast .bsg-skip-link:focus {
  outline: 3px solid #0078d7;
  color: black;
  background: white;
  border: 2px solid black;
  z-index: 10001;
}
.bsg-high-contrast .show-option-groups {
  border-bottom: 1px solid black;
}
.bsg-high-contrast .style-block > div {
  border-bottom: 1px solid #cccccc;
}
.bsg-high-contrast .visually-hidden {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/modal-info/modal-info.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAAA,6CAAA;AAGA,qCAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AADF;;AAIA,iCAAA;AACA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,iCAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;EACA,0CAAA;EACA,qBAAA;AADF;AAGE;EACE,SAAA;EACA,UAAA;AADJ;;AAKA,qBAAA;AACA;EACE,kBAAA;EACA,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,kBAAA;AAFF;;AAKA;EACE,sBAAA;EACA,uBAAA;EACA,yCAAA;AAFF;;AAKA;EACE,sBAAA;AAFF;;AAKA;EACE,uBAAA;AAFF;;AAKA,wBAAA;AACA;EACE,MAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,cAAA;AAFF;AAIE;EACE,sBAAA;AAFJ;;AAMA,0BAAA;AACA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;AAHF;;AAMA,qBAAA;AACA;EACE,SAAA;EACA,eAAA;EACA,iCAAA;AAHF;;AAMA,gBAAA;AACA;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,iBAAA;EAMA,gBAAA;EAKA,qBAAA;AAbF;AAGE;EACE,2CAAA;EACA,mBAAA;AADJ;AAKE;EACE,qCAAA;AAHJ;AAOE;EACE,2CAAA;EACA,mBAAA;AALJ;AAQE;EACE,WAAA;EACA,YAAA;AANJ;;AAUA,oBAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,2DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAMA,iBAAA;EAMA,qBAAA;EAMA,gBAAA;AAtBF;AAME;EACE,gBAAA;AAJJ;AAQE;EACE,2CAAA;EACA,mBAAA;AANJ;AAUE;EACE,2CAAA;EACA,mBAAA;AARJ;AAYE;EACE,qCAAA;AAVJ;AAaE;EACE,WAAA;EACA,YAAA;AAXJ;;AAeA,yBAAA;AACA;EACE,kBAAA;EACA,SAAA;AAZF;;AAeA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAZF;AAcE;EACE,YAAA;EACA,uBAAA;AAZJ;;AAgBA,+BAAA;AACA;EACE,2BAAA;AAbF;AAeE;EACE,gBAAA;EACA,eAAA;EACA,gDAAA;EACA,kBAAA;EACA,iBAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,gBAAA;EACA,2CAAA;EACA,gCAAA;EACA,+CAAA;EACA,oBAAA;EACA,iCAAA;AAdJ;;AAkBA,gBAAA;AACA;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,iBAAA;EAMA,qBAAA;EAMA,gBAAA;AA1BF;AAeE;EACE,2CAAA;EACA,mBAAA;AAbJ;AAiBE;EACE,2CAAA;EACA,mBAAA;AAfJ;AAmBE;EACE,qCAAA;AAjBJ;AAoBE;EACE,eAAA;AAlBJ;;AAsBA,wBAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;AAnBF;AAqBE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oCAAA;EACA,+CAAA;EACA,YAAA;EACA,+BAAA;EACA,0BAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EAEA,iBAAA;EAMA,qBAAA;EAMA,gBAAA;AA9BJ;AAmBI;EACE,2CAAA;EACA,mBAAA;AAjBN;AAqBI;EACE,2CAAA;EACA,mBAAA;AAnBN;AAuBI;EACE,cAAA;EACA,0BAAA;AArBN;ACrPE;ED8OA;IAgCI,UAAA;IACA,iBAAA;EArBJ;AACF;;AAyBA,wBAAA;AACA;EACE,YAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,gBAAA;EACA,2BAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;AAtBF;;AAyBA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;AAtBF;;AAyBA;EACE,YAAA;AAtBF;;AAyBA,gBAAA;AACA;EACE,uBAAA;AAtBF;AAwBE;EACE,4CAAA;EACA,mBAAA;EACA,mBAAA;EAEA,iBAAA;AAvBJ;AAwBI;EACE,sCAAA;EACA,8CAAA;AAtBN;AA0BE;EACE,kBAAA;AAxBJ;AA0BI;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,iCAAA;AAxBN;;AA6BA,qBAAA;AACA;EACE,aAAA;EACA,mBAAA;AA1BF;AA4BE;EACE,WAAA;EACA,YAAA;AA1BJ;AA6BE;EACE,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,iCAAA;AA3BJ;;AA+BA,6BAAA;AACA;EACE,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;AA5BF;AA8BE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EAEA,iBAAA;EAKA,qBAAA;AAjCJ;AA6BI;EACE,8CAAA;AA3BN;AA+BI;EACE,8CAAA;AA7BN;AAgCI;EACE,6CAAA;EACA,0CAAA;EACA,eAAA;AA9BN;AAgCM;EACE,kBAAA;AA9BR;AAkCI;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AAhCN;AAoCE;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;AAlCJ;AAoCI;EACE,gCAAA;EACA,eAAA;EACA,iCAAA;AAlCN;AAqCI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAnCN;AAqCM;EACE,oCAAA;EACA,eAAA;EACA,iCAAA;AAnCR;;AAyCA,6BAAA;AACA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAtCF;AAwCE;EACE,iCAAA;EACA,eAAA;EACA,wBAAA;EACA,cAAA;AAtCJ;AAyCE;EACE,uBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EAEA,iBAAA;EAMA,qBAAA;EAMA,gBAAA;AAlDJ;AAuCI;EACE,2CAAA;EACA,mBAAA;AArCN;AAyCI;EACE,2CAAA;EACA,mBAAA;AAvCN;AA2CI;EACE,qCAAA;AAzCN;AA4CI;EACE,YAAA;AA1CN;AA6CI;EACE,mBAAA;AA3CN;AA8CI;EACE,WAAA;EACA,YAAA;AA5CN;;AAiDA,qCAAA;AACA;EACE,YAAA;EACA,gBAAA;EACA,qBAAA;AA9CF;;AAiDA,0DAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AA9CF;;AAiDA,8BAAA;AAEE;EACE,2CAAA;EACA,mBAAA;AA/CJ;;AAmDA,8BAAA;AACA;EACE,oCAAA;EASA,0BAAA;EAyBA,qBAAA;EASA,yBAAA;EAoBA,kBAAA;EAeA,oBAAA;EAoDA,sCAAA;EAOA,kDAAA;EASA,wCAAA;EAKA,yDAAA;EAKA,yDAAA;AAlMF;AAuCE;EACE,kCAAA;AArCJ;AAwCE;EACE,4BAAA;AAtCJ;AA2CI;EACE,0BAAA;AAzCN;AA4CI;EACE,YAAA;AA1CN;AA8CE;EACE,iBAAA;EACA,uBAAA;EACA,gBAAA;AA5CJ;AA8CI;EACE,0BAAA;AA5CN;AA+CI;EACE,YAAA;AA7CN;AAkDE;EACE,uBAAA;AAhDJ;AAmDE;EACE,uBAAA;AAjDJ;AAsDI;EACE,0BAAA;AApDN;AAuDI;EACE,YAAA;AArDN;AAyDE;EACE,yBAAA;EACA,0BAAA;AAvDJ;AAyDI;EACE,0BAAA;AAvDN;AA4DE;EACE,mBAAA;AA1DJ;AA4DI;EACE,qBAAA;EACA,6CAAA;AA1DN;AA8DE;EACE,4BAAA;EACA,uBAAA;AA5DJ;AAgEE;EACE,iBAAA;EACA,2BAAA;AA9DJ;AAgEI;EACE,uBAAA;AA9DN;AAiEI;EAKE,iDAAA;EAUA,6CAAA;AA5EN;AA8DM;EACE,6BAAA;AA5DR;AAgEM;EACE,uBAAA;EACA,iBAAA;AA9DR;AAiEM;EACE,uBAAA;AA/DR;AAmEM;EACE,YAAA;EACA,wBAAA;AAjER;AAmEQ;EACE,yBAAA;AAjEV;AAuEE;EASE,0BAAA;AA7EJ;AAqEI;EACE,0BAAA;AAnEN;AAsEI;EACE,YAAA;AApEN;AAwEI;EACE,YAAA;EACA,wBAAA;AAtEN;AA4EI;EACE,uBAAA;AA1EN;AA+EE;EACE,0BAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;AA7EJ;AAiFE;EACE,8BAAA;AA/EJ;AAmFE;EACE,gCAAA;AAjFJ;AAqFE;EACE,aAAA;AAnFJ","sourcesContent":["/* BSG-compliant styles for food item modal */\n@import \"../../../theme/mixins\";\n\n/* Utility class for screen readers */\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n/* Skip link for keyboard users */\n.bsg-skip-link {\n  position: absolute;\n  top: -9999px;\n  left: -9999px;\n  background: white;\n  color: var(--ion-color-secondary);\n  padding: 15px;\n  z-index: 10000;\n  font-weight: bold;\n  border: 2px solid var(--ion-color-primary);\n  text-decoration: none;\n  \n  &:focus {\n    top: 10px;\n    left: 10px;\n  }\n}\n\n/* Container styles */\n.bsg-modal-container {\n  position: relative;\n  height: 100%;\n}\n\napp-modal-info {\n  height: 100vh;\n  position: relative;\n}\n\nswiper-container {\n  width: 100% !important;\n  height: 100% !important;\n  background-color: var(--background-color);\n}\n\nswiper-slide {\n  width: 100% !important;\n}\n\nion-page {\n  background: transparent;\n}\n\n/* Slide column styles */\n.slide-col {\n  top: 0;\n  bottom: 0;\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  background-size: 100% 30vh !important;\n  overflow: auto;\n  \n  &.add-background {\n    background-size: cover;\n  }\n}\n\n/* Header wrapper styles */\n.header-wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 20px;\n  align-items: center;\n}\n\n/* Category heading */\n.category-heading {\n  margin: 0;\n  font-size: 18px;\n  color: var(--ion-color-secondary);\n}\n\n/* Back button */\n.bsg-back-button {\n  background: transparent;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  \n  /* Focus styles */\n  &:focus {\n    outline: 3px solid var(--ion-color-primary);\n    outline-offset: 2px;\n  }\n  \n  /* Hover state */\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n  \n  /* Key focus styles */\n  &:focus-visible {\n    outline: 3px solid var(--ion-color-primary);\n    outline-offset: 2px;\n  }\n  \n  ion-icon {\n    width: 20px;\n    height: 20px;\n  }\n}\n\n/* Favorite button */\n.add_fav_btn {\n  width: 40px;\n  height: 40px;\n  background: white;\n  border-radius: 50%;\n  box-shadow: 0px 0px 20px 0px #4F614F26;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  &.no-shadow {\n    box-shadow: none;\n  }\n  \n  /* Focus styles */\n  &:focus {\n    outline: 3px solid var(--ion-color-primary);\n    outline-offset: 2px;\n  }\n  \n  /* Key focus styles */\n  &:focus-visible {\n    outline: 3px solid var(--ion-color-primary);\n    outline-offset: 2px;\n  }\n  \n  /* Hover state */\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.02);\n  }\n  \n  ion-icon {\n    width: 25px;\n    height: 25px;\n  }\n}\n\n/* Image wrapper styles */\n.image-wrapper {\n  position: relative;\n  margin: 0;\n}\n\n.main-img {\n  height: 30vh;\n  width: 100%;\n  margin: 0 auto 0px;\n  \n  &.default-img {\n    height: 35vh;\n    width: 100px !important;\n  }\n}\n\n/* Information section styles */\n.info {\n  padding: 20px 20px 0px 20px;\n  \n  .title {\n    text-align: left;\n    font-size: 25px;\n    line-height: var(--modal-info-title-line-height);\n    margin-bottom: 6px;\n    padding-top: 10px;\n    color: var(--ion-color-secondary);\n    display: flex;\n    align-items: center;\n  }\n  \n  .desc {\n    text-align: left;\n    font-size: var(--modal-info-desc-font-size);\n    font-family: AppFont, sans-serif;\n    line-height: var(--modal-info-desc-line-height);\n    padding-bottom: 10px;\n    color: var(--ion-color-secondary);\n  }\n}\n\n/* Info button */\n.bsg-info-button {\n  background: transparent;\n  border: none;\n  padding: 8px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 50%;\n  margin-left: 5px;\n  \n  /* Focus styles */\n  &:focus {\n    outline: 3px solid var(--ion-color-primary);\n    outline-offset: 2px;\n  }\n  \n  /* Key focus styles */\n  &:focus-visible {\n    outline: 3px solid var(--ion-color-primary);\n    outline-offset: 2px;\n  }\n  \n  /* Hover state */\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.05);\n  }\n  \n  ion-icon {\n    font-size: 17px;\n  }\n}\n\n/* Ingredients section */\n.ingrediants-section {\n  display: flex;\n  justify-content: flex-end;\n  padding: 10px 0px;\n  align-items: center;\n  width: 100%;\n  \n  .bsg-remove-ingredients-button {\n    cursor: pointer;\n    text-align: left;\n    font-size: 16px;\n    font-family: AppFontBold, sans-serif;\n    line-height: var(--modal-info-desc-line-height);\n    padding: 8px;\n    color: var(--ion-color-primary);\n    text-decoration: underline;\n    background: transparent;\n    border: none;\n    border-radius: 4px;\n    \n    /* Focus styles */\n    &:focus {\n      outline: 3px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Key focus styles */\n    &:focus-visible {\n      outline: 3px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Hover state */\n    &:hover {\n      color: darken(#71A761, 10%);\n      text-decoration: underline;\n    }\n    \n    @include mobile {\n      width: 50%;\n      text-align: right;\n    }\n  }\n}\n\n/* Option group styles */\n.option-group-col {\n  flex-grow: 1;\n  overflow: auto;\n  flex-shrink: 1;\n  flex-basis: auto;\n  padding: 15px 20px;\n}\n\n.option-group-description {\n  line-height: 1.3;\n  padding: 10px 25px 0px 20px;\n  color: var(--ion-color-secondary);\n  font-size: 16px;\n  text-align: left;  \n  font-family: AppFontBold, sans-serif;\n}\n\n.show-option-groups {\n  background: white;\n  display: flex;\n  align-items: center;\n}\n\n.last-item {\n  height: 75px;\n}\n\n/* Notes input */\n.input-notes {\n  padding: 20px 20px 80px;\n  \n  ion-item {\n    border: 1.5px solid var(--ion-color-primary);\n    border-radius: 16px;\n    margin-bottom: 10px;\n    \n    /* Focus styles */\n    &:focus-within {\n      border-color: var(--ion-color-primary);\n      box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n    }\n  }\n  \n  .container {\n    position: relative;\n    \n    ion-label {\n      position: absolute;\n      left: 20px;\n      background: white;\n      top: -7px;\n      z-index: 999;\n      padding: 0px 10px;\n      color: var(--ion-color-secondary);\n    }\n  }\n}\n\n/* Vegan indicators */\n.vegan-block {\n  display: flex;\n  align-items: center;\n  \n  ion-img {\n    width: 35px;\n    height: 24px;\n  }\n  \n  p {\n    text-transform: capitalize;\n    margin-right: 5px;\n    font-size: 12px;\n    color: var(--ion-color-secondary);\n  }\n}\n\n/* Footer and button styles */\n.button-footer-block {\n  background: white;\n  margin: 0px !important;\n  padding: 15px;\n  position: fixed;\n  bottom: 0px;\n  left: 0px;\n  width: 100%;\n  z-index: 999;\n  box-shadow: 0px -4px 50px 0px #0000001A;\n  display: flex;\n  flex-direction: column;\n  font-size: 16px;\n  \n  ion-button {\n    --padding-start: 24px;\n    --padding-end: 7px;\n    width: 100%;\n    position: relative;\n    \n    /* Focus styles */\n    &:focus {\n      box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n    }\n    \n    /* Key focus styles */\n    &:focus-visible {\n      box-shadow: 0 0 0 3px rgba(113, 167, 97, 0.25);\n    }\n    \n    .buuton-text {\n      font-size: var(--modal-info-button-font-size);\n      color: var(--modal-info-button-text-color);\n      margin-right: 0;\n      \n      &.one-button {\n        margin-right: 35px;\n      }\n    }\n    \n    .button-icon {\n      position: absolute;\n      right: 5px;\n      height: 34px;\n      width: 34px;\n    }\n  }\n  \n  .footer-price-section {\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 10px;\n    \n    .text-hint {\n      font-family: AppFont, sans-serif;\n      font-size: 14px;\n      color: var(--ion-color-secondary);\n    }\n    \n    .wrapper-with-quantity {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      \n      .price-text {\n        font-family: AppFontBold, sans-serif;\n        font-size: 18px;\n        color: var(--ion-color-secondary);\n      }\n    }\n  }\n}\n\n/* Quantity selector styles */\n.quantity-selector {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  \n  .quantity {\n    color: var(--ion-color-secondary);\n    font-size: 20px;\n    font-family: AppFontBold;\n    margin: 0 10px;\n  }\n  \n  .quantity-btn {\n    background: transparent;\n    border: none;\n    padding: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border-radius: 50%;\n    \n    /* Focus styles */\n    &:focus {\n      outline: 3px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Key focus styles */\n    &:focus-visible {\n      outline: 3px solid var(--ion-color-primary);\n      outline-offset: 2px;\n    }\n    \n    /* Hover state */\n    &:hover:not([disabled]) {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n    \n    &.add-opacity {\n      opacity: 0.5;\n    }\n    \n    &[disabled] {\n      cursor: not-allowed;\n    }\n    \n    ion-icon {\n      width: 30px;\n      height: 30px;\n    }\n  }\n}\n\n/* Container for scrollable content */\n.style-block {\n  height: 100%;\n  overflow-y: auto;\n  padding-bottom: 120px;\n}\n\n/* Focus trap marker elements for modal focus management */\n.bsg-focus-trap-start, .bsg-focus-trap-end {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  border: 0;\n}\n\n/* Keyboard focus indicators */\n.bsg-keyboard-focus {\n  &:focus-visible {\n    outline: 3px solid var(--ion-color-primary);\n    outline-offset: 2px;\n  }\n}\n\n/* High contrast mode styles */\n.bsg-high-contrast {\n  /* Background and container styles */\n  swiper-container {\n    background-color: white !important;\n  }\n  \n  .slide-col {\n    background: white !important;\n  }\n  \n  /* Header and navigation */\n  .bsg-back-button {\n    &:focus {\n      outline: 3px solid #0078d7;\n    }\n    \n    ion-icon {\n      color: black;\n    }\n  }\n  \n  .add_fav_btn {\n    background: white;\n    border: 2px solid black;\n    box-shadow: none;\n    \n    &:focus {\n      outline: 3px solid #0078d7;\n    }\n    \n    ion-icon {\n      color: black;\n    }\n  }\n  \n  /* Text and content */\n  .title, .desc, .category-heading, .option-group-description {\n    color: black !important;\n  }\n  \n  .info .desc {\n    color: black !important;\n  }\n  \n  /* Interactive elements */\n  .bsg-info-button {\n    &:focus {\n      outline: 3px solid #0078d7;\n    }\n    \n    ion-icon {\n      color: black;\n    }\n  }\n  \n  .bsg-remove-ingredients-button {\n    color: #0078d7 !important;\n    text-decoration: underline;\n    \n    &:focus {\n      outline: 3px solid #0078d7;\n    }\n  }\n  \n  /* Form elements */\n  .input-notes ion-item {\n    border-color: black;\n    \n    &:focus-within {\n      border-color: #0078d7;\n      box-shadow: 0 0 0 3px rgba(0, 120, 215, 0.25);\n    }\n  }\n  \n  ion-label {\n    background: white !important;\n    color: black !important;\n  }\n  \n  /* Footer elements */\n  .button-footer-block {\n    background: white;\n    border-top: 2px solid black;\n    \n    .text-hint, .price-text, .quantity {\n      color: black !important;\n    }\n    \n    ion-button {\n      &:focus {\n        box-shadow: 0 0 0 3px #0078d7;\n      }\n      \n      /* Add higher contrast to button text and icons */\n      .buuton-text {\n        color: white !important;\n        font-weight: bold;\n      }\n      \n      .button-icon {\n        color: white !important;\n      }\n      \n      /* Disabled button styles for high contrast */\n      &[disabled] {\n        opacity: 0.6;\n        border: 1px dashed black;\n        \n        .buuton-text {\n          color: #666666 !important;\n        }\n      }\n    }\n  }\n  \n  .quantity-btn {\n    &:focus {\n      outline: 3px solid #0078d7;\n    }\n    \n    ion-icon {\n      color: black;\n    }\n    \n    /* Disabled button style */\n    &[disabled], &.add-opacity {\n      opacity: 0.5;\n      border: 1px dashed black;\n    }\n  }\n  \n  /* Vegan indicators in high contrast */\n  .vegan-block {\n    ion-img {\n      border: 1px solid black;\n    }\n  }\n  \n  /* Improve skip link visibility in high contrast */\n  .bsg-skip-link:focus {\n    outline: 3px solid #0078d7;\n    color: black;\n    background: white;\n    border: 2px solid black;\n    z-index: 10001;\n  }\n  \n  /* Enhance visibility of option groups */\n  .show-option-groups {\n    border-bottom: 1px solid black;\n  }\n  \n  /* Add borders to sections for better visual separation */\n  .style-block > div {\n    border-bottom: 1px solid #cccccc;\n  }\n  \n  /* Announce screen reader content in high contrast mode */\n  .visually-hidden {\n    display: none;\n  }\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
